__turbopack_context__.v({
  "anchor": "tweet-media-video-module__CjSC8q__anchor",
  "videoButton": "tweet-media-video-module__CjSC8q__videoButton",
  "videoButtonIcon": "tweet-media-video-module__CjSC8q__videoButtonIcon",
  "viewReplies": "tweet-media-video-module__CjSC8q__viewReplies",
  "watchOnTwitter": "tweet-media-video-module__CjSC8q__watchOnTwitter",
});
